// src/common/components/cartModal/components/bonusMotivator/BonusMotivator.tsx
import React, { useMemo } from 'react'
import { useTheme } from '../../../../hooks/useTheme'
import styles from './BonusMotivator.module.scss'

interface BonusMotivatorProps {
  text: string | null
}

export default function BonusMotivator({ text }: BonusMotivatorProps) {
  const { theme } = useTheme()

  if (!text) return null

  return (
    <div className={styles.container} style={{ 
      backgroundColor: theme.card,
      borderColor: theme.border 
    }}>
      <p className={styles.text} style={{ color: theme.textSecondary }}>
        {text}
      </p>
    </div>
  )
}